<template>
	<div>
		<CommonFlame :title="`精錬工程表`" :maxWidth="'auto'">
			<template v-if="!$vuetify.breakpoint.xs" v-slot:app-bar-btn>
				<!-- <HelpDialog :name="'manufactureRubberProcessIndexChart'" openBtnColor="primary" /> -->
				<!-- <ManufactureProcessSearchDialog
					:query.sync="q"
					:processQuery.sync="processQuery"
					:categories="categories"
					:situations="situations"
					:form_type.sync="formType"
					text
					@search-items="searchRubberProcesses(q)"
					@search-items-by-process="searchOrderIndividualInfosByProcess(processQuery)"
				/> -->
				<MachineNewDialog
					v-if="machine_authorized"
					:machine_type="'rubber_kneading'"
					@create-machine="createMachine($event)"
					text
				/>
			</template>
			<template v-else v-slot:app-bar-btn>
				<MachineNewDialog
					v-if="machine_authorized"
					:machine_type="'rubber_kneading'"
					@create-machine="createMachine($event)"
				/>
				<!-- <HelpDialog :name="'manufactureRubberProcessIndexChart'" openBtnColor="white" onlyIcon /> -->
			</template>
			<GanttChart
				:taskTitle="'成果物名'"
				:categories="showTray ? machines : displayMachines"
				:tasks="ganttChartProcesses"
				:categoryNameKey="'name'"
				:taskNameKey="'id'"
				:startDateKey="dateTimeKey.startDateKey"
				:endDateKey="dateTimeKey.endDateKey"
				:startTimeKey="dateTimeKey.startTimeKey"
				:endTimeKey="dateTimeKey.endTimeKey"
				:fontSize="fontSize"
				:topSectionPosition="'right'"
				:isWindowSizeCheck="isWindowSizeCheck"
				:isDraggable="showTray"
				:showDates="true"
				:categoryRecognitionId="'machine_id'"
				:taskBarStyle="taskBarStyle"
				:taskBarNameStyle="taskBarNameStyle"
				:colorRecognitionKey="'situation'"
				:taskBarColorsByRecognitionKey="taskBarColorsByRecognitionKey"
				:editableRecognitionKey="'situation'"
				:editableByRecognitionKey="editableByRecognitionKey"
				:taskBarType="'bar'"
				:changeDatetimeFlag="authorized"
				:taskClickable="true"
				:display_date.sync="display_date"
				:start_date="start_date"
				:end_date="end_date"
				:chart_type.sync="chartType"
				syncChartType
				:dateChartSpanUnit="'months'"
				:dateChartSpan="3"
				:show_tray.sync="showTray"
				@change-datetime="changeDatetime($event)"
				@change-display-date="changeDisplayDate($event)"
				@update-task="setMachineId($event)"
				@remove-task="resetMachineId($event)"
			>
				<template v-slot:left-time-btn>
					<v-menu close-on-click :close-on-content-click="false">
						<template v-slot:activator="{ on, attrs }">
							<v-btn color="secondary" class="mr-2 mb-4" v-bind="attrs" v-on="on">
								<v-icon class="mr-1"> mdi-application-cog-outline</v-icon>表示設定
							</v-btn>
						</template>
						<v-card width="340px">
							<v-app-bar dark color="primary" height="32px" elevation="0">
								<h6 class="text-body-2 font-weight-bold white--text">表示設定</h6>
							</v-app-bar>
							<v-sheet class="pa-2" elevation="0">
								<h6 class="text-body-2 font-weight-bold">工程の開始・終了日時</h6>
								<v-radio-group v-model="displayDateType" @change="changeDisplayDateType">
									<v-radio
										v-for="(type, i) in displayDateTypes"
										:key="i"
										:label="type.name"
										:value="type.value"
									/>
								</v-radio-group>
							</v-sheet>
						</v-card>
					</v-menu>
				</template>

				<template v-slot:right-time-btn>
					<v-text-field
						class="ml-2 no-line"
						label="現在表示しているデータ"
						outlined
						dense
						v-model="displayDateName"
						readonly
						hide-details
					/>
				</template>

				<template v-slot:task-top-section="{ showDates, taskTitle }">
					<v-col :cols="showDates ? 4 : 12" class="gantt-task">{{ taskTitle }}</v-col>
					<template v-if="showDates">
						<v-col cols="4" class="gantt-start">開始</v-col>
						<v-col cols="4" class="gantt-end">完了</v-col>
					</template>
				</template>

				<template v-slot:app-bar-btn>
					<v-row no-gutters justify="end" align="baseline">
						<v-col cols="12" sm="6" md="4" class="pr-sm-2">
							<v-row no-gutters :justify="$vuetify.breakpoint.xs ? '' : 'end'">
								<v-switch v-model="showTray" label="機械に割当をする" hide-details />
							</v-row>
						</v-col>
						<v-col cols="12" sm="6" md="4">
							<v-select
								label="加工の種類を選択"
								v-model="selectedTypeId"
								:items="rubber_process_types"
								item-text="name"
								item-value="id"
								outlined
								dense
								hide-details
								no-data-text="加工の種類を取得できませんでした。"
								class="mb-4"
								@change="changeSelectedTypeId"
							/>
						</v-col>
					</v-row>

					<v-row no-gutters justify="end" align="baseline">
						<div
							v-for="(situation, i) in situations"
							class="px-1 text-body-2 mt-sm-0 mt-2"
							:key="i"
						>
							<span :style="{ color: taskBarColorsByRecognitionKey[situation.value] }"> ● </span>
							{{ situation.name }}
						</div>
						<v-btn
							class="ml-2 mt-sm-0 mt-2"
							color="secondary"
							:disabled="!changedProcesses.length"
							@click="saveChangedProcesses"
							>変更を保存する</v-btn
						>
					</v-row>
				</template>
				<template v-slot:category-name="{ task }">
					<v-hover v-slot="{ hover }" close-delay="200" open-delay="200">
						<div>
							<span :style="{ fontSize: '0.85rem' }">{{ task.name }}</span>
							<v-btn
								v-if="hover && machine_authorized && task.id"
								icon
								color="grey"
								class="ml-2"
								@click="openMachineEditDialog(task)"
							>
								<v-icon class="mr-1">mdi-pencil</v-icon>
							</v-btn>
						</div>
					</v-hover>
				</template>

				<template
					v-slot:task-list="{ task, startDateKey, startTimeKey, endDateKey, endTimeKey, showDates }"
				>
					<v-hover v-slot="{ hover }" close-delay="200" open-delay="200">
						<v-col :cols="showDates ? 4 : 12" class="task-name task-time">
							{{ mainDeliverableName(task) }}
							<v-btn
								class="edit-icon-btn"
								v-show="hover"
								small
								icon
								@click.stop="selectItemById(task)"
								><v-icon>mdi-information</v-icon></v-btn
							>
						</v-col>
					</v-hover>
					<template v-if="showDates">
						<v-hover v-slot="{ hover }" close-delay="200" open-delay="200">
							<v-col cols="4" class="task-time" @click.stop="setPositionByTime(task, startDateKey)">
								{{ common.formatDateWithNullableTime(task, startDateKey, startTimeKey) }}
								<v-btn
									v-if="authorized"
									class="edit-icon-btn"
									v-show="hover"
									small
									icon
									@click.stop="openEditSmallDialog(task)"
									><v-icon>mdi-pencil</v-icon></v-btn
								>
							</v-col>
						</v-hover>
						<v-hover v-slot="{ hover }" close-delay="200" open-delay="200">
							<v-col cols="4" class="task-time" @click.stop="setPositionByTime(task, endDateKey)">
								{{ common.formatDateWithNullableTime(task, endDateKey, endTimeKey) }}
								<v-btn
									v-if="authorized"
									class="edit-icon-btn"
									v-show="hover"
									small
									icon
									@click.stop="openEditSmallDialog(task)"
									><v-icon>mdi-pencil</v-icon></v-btn
								>
							</v-col>
						</v-hover>
					</template>
				</template>

				<template v-slot:task-name="{ task }">
					{{
						selectedTypeId
							? mainDeliverableName(task)
							: rubberProcessTypeNameById(task.rubber_process_type_id)
					}}
				</template>

				<template v-slot:no-categorized-task-text>
					機械に設定されていないゴム加工はありません。
				</template>
			</GanttChart>

			<v-menu
				:close-on-content-click="false"
				v-model="editSmallDialog"
				:position-x="editMenu.x"
				:position-y="editMenu.y"
				@click:outside="closeEditSmallDialog()"
			>
				<v-card>
					<v-app-bar dark color="primary" height="36px" elevation="0">
						<v-spacer />
						<v-btn icon @click="closeEditSmallDialog()">
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-app-bar>
					<v-sheet elevation="0" class="pa-2">
						<v-form v-model="valid">
							<v-row no-gutters>
								<v-col cols="12" sm="6" class="pr-sm-1">
									<v-menu
										ref="menu"
										:close-on-content-click="false"
										close-on-click
										transition="scale-transition"
										offset-y
										min-width="auto"
									>
										<template v-slot:activator="{ on, attrs }">
											<v-text-field
												:label="labelByDisplayDateType('startDate')"
												:rules="
													selectedProcessByMenu[dateTimeKey.startTimeKey] ? [rules.required] : []
												"
												:hint="
													selectedProcessByMenu[dateTimeKey.startTimeKey]
														? `${labelByDisplayDateType(
																'startTime'
														  )}がある場合は日付も入力が必要です。`
														: ''
												"
												:persistent-hint="
													selectedProcessByMenu[dateTimeKey.startTimeKey] != null &&
													!selectedProcessByMenu[dateTimeKey.startDateKey]
												"
												v-model="selectedProcessByMenu[dateTimeKey.startDateKey]"
												outlined
												dense
												readonly
												v-bind="attrs"
												v-on="on"
												class="mt-4"
											/>
										</template>
										<v-date-picker
											v-model="selectedProcessByMenu[dateTimeKey.startDateKey]"
											no-title
											scrollable
											locale="ja"
										/>
									</v-menu>
								</v-col>
								<v-col cols="12" sm="6" class="pl-sm1">
									<v-text-field
										v-model="selectedProcessByMenu[dateTimeKey.startTimeKey]"
										:label="labelByDisplayDateType('startTime')"
										class="mt-4"
										type="time"
										step="300"
										outlined
										dense
									/>
								</v-col>
							</v-row>
							<v-row no-gutters>
								<v-col cols="12" sm="6" class="pr-sm-1">
									<v-menu
										ref="menu"
										:close-on-content-click="false"
										close-on-click
										transition="scale-transition"
										offset-y
										min-width="auto"
									>
										<template v-slot:activator="{ on, attrs }">
											<v-text-field
												:label="labelByDisplayDateType('endDate')"
												:rules="
													selectedProcessByMenu[dateTimeKey.endTimeKey] ? [rules.required] : []
												"
												:hint="
													selectedProcessByMenu[dateTimeKey.endTimeKey]
														? `${labelByDisplayDateType(
																'endTime'
														  )}がある場合は日付も入力が必要です。`
														: ''
												"
												:persistent-hint="
													selectedProcessByMenu[dateTimeKey.endTimeKey] != null &&
													!selectedProcessByMenu[dateTimeKey.endDateKey]
												"
												v-model="selectedProcessByMenu[dateTimeKey.endDateKey]"
												outlined
												dense
												readonly
												v-bind="attrs"
												v-on="on"
												class="mt-4"
											/>
										</template>
										<v-date-picker
											v-model="selectedProcessByMenu[dateTimeKey.endDateKey]"
											no-title
											scrollable
											locale="ja"
										/>
									</v-menu>
								</v-col>
								<v-col cols="12" sm="6" class="pl-sm1">
									<v-text-field
										v-model="selectedProcessByMenu[dateTimeKey.endTimeKey]"
										:label="labelByDisplayDateType('endTime')"
										class="mt-4"
										type="time"
										step="300"
										outlined
										dense
									/>
								</v-col>
							</v-row>
						</v-form>
						<v-row no-gutters justify="center">
							<v-btn
								color="secondary"
								@click="updateRubberProcessByMenu"
								class="mt-4"
								:disabled="!valid"
							>
								<v-icon class="mr-1">mdi-content-save</v-icon>
								変更
							</v-btn>
						</v-row>
					</v-sheet>
				</v-card>
			</v-menu>
			<RubberProcessShowDialog
				:dialog.sync="showDialog"
				:teams="teams"
				:allowSelectTeam="authorized"
				:id="selectedId"
			/>
			<MachineEditDialog
				:dialog.sync="machineEditDialog"
				:machine_data="selectedMachine"
				:machine_type="'rubber_kneading'"
				@update-machine="updateMachine($event)"
				@delete-machine="deleteMachine($event)"
			/>
		</CommonFlame>
	</div>
</template>

<script>
import axios from "axios"
import moment from "moment"
import Qs from "qs"
import common from "../../helper/common"
import rules from "../../helper/rules"
import errorHandling from "../../helper/errorHandling"
import authenticate from "../../helper/authenticate"
import help from "../../helper/help.json"
import CommonFlame from "../shared/CommonFlame.vue"
import PaginationModule from "../shared/PaginationModule.vue"
import HelpDialog from "../shared/HelpDialog.vue"
import GanttChart from "../shared/MultipleLineGanttChart.vue"
import ShowDetailRecord from "../shared/ShowDetailRecord.vue"
import RubberProcessShowDialog from "../rubber_process/components/RubberProcessShowDialog.vue"
import MachineEditDialog from "../machine/components/MachineEditDialog.vue"
import MachineNewDialog from "../machine/components/MachineNewDialog.vue"

export default {
	components: {
		CommonFlame,
		PaginationModule,
		ShowDetailRecord,
		GanttChart,
		RubberProcessShowDialog,
		MachineEditDialog,
		MachineNewDialog,
		HelpDialog,
	},
	data() {
		return {
			common,
			rules,
			id: this.$route.params.id,
			rubberProcesses: [],
			ganttChartProcesses: [],
			machines: [],
			displayMachines: [],
			rubberProcessType: { name: "" },
			teams: [],
			q: {
				sorts: "created_at desc",
			},
			processQuery: {
				sorts: null,
				situation_not_in: [],
			},
			rubber_process_types: [],
			categories: [],
			situations: [],
			fetchedMonths: [],
			chartType: "date",
			selectedTypeId: null,
			authorized: false,
			machine_authorized: false,
			isWindowSizeCheck: false,
			selectedId: null,
			machineEditDialog: false,
			selectedMachine: {},
			selectedProcessByMenu: { id: null },
			editSmallDialog: false,
			editMenu: {
				x: null,
				y: null,
			},
			displayDateType: "scheduled",
			displayDateTypes: [
				{ name: "予定", value: "scheduled" },
				{ name: "実績", value: "result" },
			],
			dateTimeKey: {
				startTimeKey: "schedule_start_time",
				endTimeKey: "schedule_end_time",
				startDateKey: "schedule_start_date",
				endDateKey: "schedule_end_date",
			},
			tableDateTimeKey: {
				startTimeKey: "schedule_start_time",
				endTimeKey: "schedule_end_time",
				startDateKey: "schedule_start_date",
				endDateKey: "schedule_end_date",
			},
			fontSize: "14px",
			taskBarStyle: {
				textAlign: "center",
				height: "24px",
				paddingBottom: "4px",
				borderRadius: 0,
			},
			taskBarNameStyle: {
				fontSize: ".9rem",
				color: "black",
			},
			taskBarColorsByRecognitionKey: {
				requested: this.$vuetify.theme.themes.light.rubber_process.requested,
				scheduled: this.$vuetify.theme.themes.light.rubber_process.scheduled,
				ongoing: this.$vuetify.theme.themes.light.rubber_process.ongoing,
				interruption: this.$vuetify.theme.themes.light.rubber_process.interruption,
				completed: this.$vuetify.theme.themes.light.rubber_process.completed,
				canceled: this.$vuetify.theme.themes.light.rubber_process.canceled,
				result: this.$vuetify.theme.themes.light.rubber_process.completed,
			},
			editableByRecognitionKey: {
				requested: true,
				scheduled: true,
				ongoing: { right: true, left: false, drag: false },
				interruption: { right: true, left: false, drag: false },
				completed: false,
				canceled: false,
			},
			start_date: null,
			end_date: null,
			display_date: null,
			showTray: false,
			changedProcesses: [],
			showDialog: false,
			valid: false,
			help: help,
		}
	},
	mounted() {
		let start_date
		let end_date
		if (this.$route.query.start_date) {
			let days = moment(this.$route.query.end_date).diff(
				moment(this.$route.query.start_date),
				"days"
			)
			if (days == 6) {
				this.chartType = "time"
				this.start_date = moment(this.$route.query.start_date).format("YYYY-MM-DD")
				this.end_date = moment(this.$route.query.end_date).format("YYYY-MM-DD")
				start_date = moment(this.$route.query.start_date).startOf("month").format("YYYY-MM-DD")
				end_date = moment(this.$route.query.end_date).endOf("month").format("YYYY-MM-DD")
			} else {
				this.start_date = moment(this.$route.query.start_date).startOf("month").format("YYYY-MM-DD")
				this.end_date = moment(this.start_date).add(2, "months").endOf("month").format("YYYY-MM-DD")
			}
		} else {
			this.start_date = moment().subtract(1, "months").startOf("month").format("YYYY-MM-DD")
			this.end_date = moment(this.start_date).add(2, "months").endOf("month").format("YYYY-MM-DD")
		}
		this.setFetchedMonths()
		if (this.$route.query.process_type_id)
			this.selectedTypeId = Number(this.$route.query.process_type_id)
		this.setQuery()
		this.fetchRubberProcesses(
			true,
			start_date ? start_date : this.start_date,
			end_date ? end_date : this.end_date
		)
	},

	methods: {
		// searchRubberProcesses(q) {
		// 	this.q = q
		// 	let months = this.checkFetchedMonths(this.start_date, this.end_date)
		// 	if (months.length > 0) {
		// 		this.fetchRubberProcesses(false, months[0], months[months.length - 1])
		// 	} else {
		// 		this.setGanttChartProcess()
		// 	}
		// 	this.$router.push({
		// 		name: this.$route.name,
		// 		query: {
		// 			...this.q,
		// 			start_date: this.start_date,
		// 			end_date: this.end_date,
		// 			process_type_id: this.selectedTypeId,
		// 		},
		// 	})
		// },
		changeDisplayDate(date) {
			this.start_date = date.start_date
			this.end_date = date.end_date
			let months = this.checkFetchedMonths(this.start_date, this.end_date)
			if (months.length > 0) {
				this.setFetchedMonths()
				this.fetchRubberProcesses(false, months[0], months[months.length - 1])
			} else {
				this.setGanttChartProcess()
			}
			let query = {
				...this.q,
				start_date: this.start_date,
				end_date: this.end_date,
				process_type_id: this.selectedTypeId,
			}
			// 現在のクエリと新しいクエリを比較し、異なる場合に遷移する
			if (JSON.stringify(this.$route.query) === JSON.stringify(query)) return
			this.$router.push({
				name: this.$route.name,
				query,
			})
		},
		changeSelectedTypeId(id) {
			this.selectedTypeId = id
			this.rubberProcesses = []
			this.fetchRubberProcesses(false)
			this.$router.push({
				name: this.$route.name,
				query: {
					...this.q,
					start_date: this.start_date,
					end_date: this.end_date,
					process_type_id: this.selectedTypeId,
				},
			})
		},
		fetchRubberProcesses(first_visit, start_date = null, end_date = null) {
			const headers = authenticate.setHeader()
			const params = {
				q: this.q,
				start_date: start_date ? start_date : this.start_date,
				end_date: end_date ? end_date : this.end_date,
				rubber_process_type_id: this.selectedTypeId,
				first_visit,
			}
			const paramsSerializer = (params) => Qs.stringify(params, { arrayFormat: "brackets" })
			const url = `/erp/v1/rubber_processes`
			axios
				.get(url, { headers, params, paramsSerializer })
				.then((res) => {
					res.data.rubber_processes.forEach((process) => {
						if (!this.rubberProcesses.find((p) => p.id == process.id)) {
							this.rubberProcesses.push(process)
						}
					})
					if (first_visit) {
						this.rubber_process_types = res.data.rubber_process_types
						this.authorized = res.data.authorized
						this.machine_authorized = res.data.machine_authorized
						this.machines = res.data.machines
						this.teams = res.data.teams
						this.situations = res.data.situations
						this.setMachines()
					}
					this.setGanttChartProcess()
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		confirmSave(event) {
			event.returnValue = "変更したデータは保存されませんが、よろしいですか？"
		},
		selectItemById(process) {
			const item = this.rubberProcesses.find((i) => i.id == process.id)
			if (!item) return
			this.selectedId = item.id
			this.showDialog = true
		},
		updateRubberProcess(process) {
			let item = this.rubberProcesses.find((p) => p.id == process.id)
			if (!item) return
			const index = this.rubberProcesses.indexOf(item)
			this.$set(this.rubberProcesses, index, item)
		},
		setPositionByTime(task, dateKey) {
			let date = task[dateKey]
			if (!date) return
			this.display_date = moment(date).format("YYYY-MM-DD")
		},
		changeDatetime(newProcess) {
			let params

			// 全てを表示している場合は適当した日時を絞り込む
			if (newProcess[this.dateTimeKey.startTimeKey]) {
				params = {
					[this.dateTimeKey.startDateKey]: newProcess[this.dateTimeKey.startDateKey],
					[this.dateTimeKey.endDateKey]: newProcess[this.dateTimeKey.endDateKey],
					[this.dateTimeKey.startTimeKey]: newProcess[this.dateTimeKey.startTimeKey],
					[this.dateTimeKey.endTimeKey]: newProcess[this.dateTimeKey.endTimeKey],
					id: newProcess.id,
				}
			} else {
				params = {
					[this.dateTimeKey.startDateKey]: newProcess[this.dateTimeKey.startDateKey],
					[this.dateTimeKey.endDateKey]: newProcess[this.dateTimeKey.endDateKey],
					id: newProcess.id,
				}
			}
			let oldParams = this.changedProcesses.find((p) => p.id == params.id)
			if (oldParams) {
				let paramsIndex = this.changedProcesses.indexOf(oldParams)
				Object.keys(params).forEach((key) => {
					oldParams[key] = params[key]
				})
				this.changedProcesses[paramsIndex] = oldParams
			} else {
				this.changedProcesses.push(params)
			}

			let process = this.rubberProcesses.find((p) => p.id == params.id)
			if (!process) return
			Object.keys(params).forEach((key) => {
				process[key] = params[key]
			})

			let index = this.rubberProcesses.indexOf(process)

			this.rubberProcesses[index] = process

			window.addEventListener("beforeunload", this.confirmSave)
		},
		saveChangedProcesses() {
			const headers = authenticate.setHeader()
			axios
				.put(
					`/erp/v1/bulk_rubber_processes`,
					{ rubber_processes: this.changedProcesses },
					{
						headers,
					}
				)
				.then((res) => {
					res.data.forEach((process) => {
						this.updateRubberProcess(process)
					})
					this.changedProcesses = []
					window.removeEventListener("beforeunload", this.confirmSave)
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		changeDisplayTableDateType(e) {
			if (e == "scheduled") {
				this.tableDateTimeKey.startDateKey = "schedule_start_date"
				this.tableDateTimeKey.endDateKey = "schedule_end_date"
				this.tableDateTimeKey.startTimeKey = "schedule_start_time"
				this.tableDateTimeKey.endTimeKey = "schedule_end_time"
			} else if (e == "result") {
				this.tableDateTimeKey.startDateKey = "start_date"
				this.tableDateTimeKey.endDateKey = "end_date"
				this.tableDateTimeKey.startTimeKey = "start_time"
				this.tableDateTimeKey.endTimeKey = "end_time"
			}
		},
		changeDisplayDateType(e) {
			if (e == "scheduled") {
				this.dateTimeKey.startDateKey = "schedule_start_date"
				this.dateTimeKey.endDateKey = "schedule_end_date"
				this.dateTimeKey.startTimeKey = "schedule_start_time"
				this.dateTimeKey.endTimeKey = "schedule_end_time"
			} else if (e == "result") {
				this.dateTimeKey.startDateKey = "start_date"
				this.dateTimeKey.endDateKey = "end_date"
				this.dateTimeKey.startTimeKey = "start_time"
				this.dateTimeKey.endTimeKey = "end_time"
			}
		},
		setFetchedMonths() {
			let months = []
			let currentDate = moment(this.start_date).startOf("month")

			while (currentDate.isBefore(this.end_date)) {
				months.push(currentDate.format("YYYY-MM"))
				currentDate.add(1, "month")
			}
			months.forEach((m) => {
				if (!this.fetchedMonths.includes(m)) {
					this.fetchedMonths.push(m)
				}
			})
		},
		checkFetchedMonths(start_date, end_date) {
			let months = []
			let currentDate = moment(start_date).startOf("month")
			while (currentDate.isBefore(end_date)) {
				months.push(currentDate.format("YYYY-MM"))
				currentDate.add(1, "month")
			}
			const notFetchedMonths = months.filter((m) => !this.fetchedMonths.includes(m))
			if (notFetchedMonths.length == 0) return []
			const dates = [
				moment(notFetchedMonths[0]).startOf("month").format("YYYY-MM-DD"),
				moment(notFetchedMonths[notFetchedMonths.length - 1])
					.endOf("month")
					.format("YYYY-MM-DD"),
			]
			return dates
		},
		setQuery() {
			const query = this.$route.query
			Object.keys(query).forEach((query_key) => {
				if (
					query[query_key] &&
					query_key != "page" &&
					query_key != "start_date" &&
					query_key != "end_date"
				) {
					this.q[query_key] = this.formatQuery(query[query_key])
				}
			})
		},
		openEditSmallDialog(process) {
			this.selectedProcessByMenu = {
				id: process.id,
				[this.dateTimeKey.startDateKey]: process[this.dateTimeKey.startDateKey],
				[this.dateTimeKey.endDateKey]: process[this.dateTimeKey.endDateKey],
				[this.dateTimeKey.startTimeKey]: process[this.dateTimeKey.startTimeKey]
					? moment(process[this.dateTimeKey.startTimeKey]).format("HH:mm")
					: null,
				[this.dateTimeKey.endTimeKey]: process[this.dateTimeKey.endTimeKey]
					? moment(process[this.dateTimeKey.endTimeKey]).format("HH:mm")
					: null,
			}
			this.editSmallDialog = true
			this.editMenu = {
				y: event.clientY,
				x: event.clientX,
			}
		},
		updateRubberProcessByMenu() {
			if (this.selectedProcessByMenu[this.dateTimeKey.startTimeKey])
				this.selectedProcessByMenu[this.dateTimeKey.startTimeKey] = `2000-01-01 ${
					this.selectedProcessByMenu[this.dateTimeKey.startTimeKey]
				}`
			if (this.selectedProcessByMenu[this.dateTimeKey.endTimeKey])
				this.selectedProcessByMenu[this.dateTimeKey.endTimeKey] = `2000-01-01 ${
					this.selectedProcessByMenu[this.dateTimeKey.endTimeKey]
				}`
			this.changeDatetime(this.selectedProcessByMenu)
			this.closeEditSmallDialog()
		},
		closeEditSmallDialog() {
			this.editSmallDialog = false
			this.selectedProcessByMenu = { id: null }
		},
		formatQuery(query) {
			if (query instanceof Array) {
				return query.map((v) => (isFinite(v) ? Number(v) : v))
			} else if (isFinite(query)) {
				return Number(query)
			} else {
				return query
			}
		},
		labelByDisplayDateType(key) {
			let labels
			if (this.displayDateType === "result") {
				labels = {
					startTime: "開始時間",
					endTime: "終了時間",
					startDate: "開始日",
					endDate: "終了日",
				}
			} else if (this.displayDateType === "scheduled") {
				labels = {
					startTime: "予定開始時間",
					endTime: "予定終了時間",
					startDate: "予定開始日",
					endDate: "予定終了日",
				}
			} else {
				labels = {}
			}
			return labels[key]
		},
		getOrderIndividualInfoById(order_individual_info_id) {
			const orderIndividualInfo = this.orderIndividualInfos.find(
				(item) => item.id == order_individual_info_id
			)
			return orderIndividualInfo
		},
		rubberProcessTypeById(rubber_process_type_id) {
			return this.rubber_process_types.find((item) => item.id == rubber_process_type_id)
		},
		rubberProcessTypeNameById(rubber_process_type_id) {
			const rubberProcessType = this.rubberProcessTypeById(rubber_process_type_id)
			return rubberProcessType ? rubberProcessType.name : "エラー"
		},
		mainDeliverableName(task) {
			task.main_deliverable.target.name
			if (task.main_deliverable) {
				return task.main_deliverable.target?.name
			} else {
				return "エラー"
			}
		},
		createMachine(machine) {
			this.machines.push(machine)
		},
		updateMachine(machine) {
			const index = this.machines.findIndex((item) => item.id == machine.id)
			this.machines.splice(index, 1, machine)
		},
		deleteMachine(machine) {
			const index = this.machines.findIndex((item) => item.id == machine.id)
			this.machines.splice(index, 1)
			this.rubberProcesses.forEach((process) => {
				if (process.machine_id == machine.id) {
					process.machine_id = null
				}
			})
		},
		setMachines() {
			let noMachineProcess = false
			let machines = []
			this.ganttChartProcesses.forEach((process) => {
				// 未設定の工程があればtrue
				if (!process.machine_id) {
					noMachineProcess = true
				}
				// 機械が設定されている工程の機械を追加
				let machine = this.machines.find((machine) => machine.id == process.machine_id)
				if (machine && !machines.includes(machine)) {
					machines.push(machine)
				}
			})

			// 未設定の工程があれば、未設定を追加して、すべての機械を返す
			if (noMachineProcess) {
				// 工程のない機械を追加
				this.machines
					.filter((machine) => !machines.includes(machine))
					.forEach((machine) => {
						machines.push(machine)
					})
				machines.push({ id: null, name: "未設定" })
			}
			this.displayMachines = machines
		},
		openMachineEditDialog(task) {
			this.selectedMachine = task
			this.machineEditDialog = true
		},
		setMachineId(updatedRubberProcess) {
			console.log(updatedRubberProcess)
			let oldParams = this.changedProcesses.find((p) => p.id == updatedRubberProcess.id)
			if (oldParams) {
				let paramsIndex = this.changedProcesses.indexOf(oldParams)
				oldParams.machine_id = updatedRubberProcess.machine_id
				this.changedProcesses[paramsIndex] = oldParams
			} else {
				this.changedProcesses.push(updatedRubberProcess)
			}

			let process = this.rubberProcesses.find((p) => p.id == updatedRubberProcess.id)
			if (!process) return
			process.machine_id = updatedRubberProcess.machine_id
			let index = this.rubberProcesses.indexOf(process)
			this.rubberProcesses[index] = process
			window.addEventListener("beforeunload", this.confirmSave)
		},
		resetMachineId(id) {
			console.log(id)
			let oldParams = this.changedProcesses.find((p) => p.id == id)
			if (oldParams) {
				let paramsIndex = this.changedProcesses.indexOf(oldParams)
				oldParams.machine_id = null
				this.changedProcesses[paramsIndex] = oldParams
			} else {
				this.changedProcesses.push({ id: id, machine_id: null })
			}

			let process = this.rubberProcesses.find((p) => p.id == id)
			if (!process) return
			process.machine_id = null
			let index = this.rubberProcesses.indexOf(process)
			this.rubberProcesses[index] = process
			this.setGanttChartProcess()
			window.addEventListener("beforeunload", this.confirmSave)
		},
		setGanttChartProcess() {
			this.ganttChartProcesses = this.rubberProcesses.filter((process) => {
				return (
					moment(process[this.dateTimeKey.startDateKey]).isBetween(
						this.start_date,
						this.end_date,
						null,
						"[]"
					) ||
					moment(process[this.dateTimeKey.endDateKey]).isBetween(
						this.start_date,
						this.end_date,
						null,
						"[]"
					)
				)
			})
			this.setMachines()
		},
	},
	watch: {
		machines(newVal, _) {
			this.setMachines()
		},
	},
	computed: {
		taskArrayName() {
			return "rubber_processes"
		},
		displayDateName() {
			if (this.displayDateType === "result") {
				return "実績"
			} else if (this.displayDateType === "scheduled") {
				return "予定"
			} else {
				return ""
			}
		},

		keyByDisplayDateType() {
			if (this.displayDateType === "result") {
				return {
					startTimeKey: "start_time",
					endTimeKey: "end_time",
					startDateKey: "start_date",
					endDateKey: "end_date",
				}
			} else if (this.displayDateType === "scheduled") {
				return {
					startTimeKey: "scheduled_start_time",
					endTimeKey: "scheduled_end_time",
					startDateKey: "scheduled_start_date",
					endDateKey: "scheduled_end_date",
				}
			} else {
				return {}
			}
		},
	},
	destroyed() {
		window.removeEventListener("beforeunload", this.confirmSave)
	},
	beforeRouteLeave(to, from, next) {
		if (!this.changedProcesses.length) {
			window.removeEventListener("beforeunload", this.confirmSave)
			next()
			return
		}
		const answer = window.confirm("変更したデータは保存されませんが、よろしいですか？")
		if (answer) {
			window.removeEventListener("beforeunload", this.confirmSave)
			next()
		} else {
			next(false)
		}
	},
}
</script>

<style lang="scss" scoped>
.task-time {
	position: relative;
	text-align: center;
	font-size: 0.85rem;
	border-right: solid 1px #80808045;
	.edit-icon-btn {
		position: absolute;
		top: 4px;
		right: 4px;
	}
}
</style>